import { c as _c } from "react/compiler-runtime";
import type { PrV2RequestedTeam } from '@/lib/pr-v2/metadata-summary';
import { Users } from 'lucide-react';

/** One requested-team entry in the sidebar reviewers list */
export function RequestedTeamRow(t0) {
  const $ = _c(3);
  const {
    team
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span className="flex size-5 shrink-0 items-center justify-center rounded-full bg-zinc-800"><Users className="size-3 text-zinc-400" /></span>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== team.name) {
    t2 = <div className="flex items-center gap-2 text-zinc-300" data-testid="pr-v2-requested-team-row">{t1}<span className="truncate text-sm">{team.name}</span></div>;
    $[1] = team.name;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}